module.exports = __webpack_public_path__ + "img/flat-roof.d3c723e8.png";